import React from "react";

import DateTimeFormatter from "@/common/DateTimeFormatter/DateTimeFormatter";

import { Tracker } from "@/features/trackers/types";

interface TrackersRowProps {
  tracker: Tracker;
}

const TrackersRow: React.FC<TrackersRowProps> = ({ tracker }) => {
  const {
    audio_type: audioType,
    channel,
    master_account: masterAccount,
    play_time: playTime,
    song,
    zone,
  } = tracker;

  return (
    <tr>
      <td>{masterAccount}</td>
      <td>{zone}</td>
      <td>{audioType}</td>
      <td>{song}</td>
      <td>
        <DateTimeFormatter timestamp={playTime} />
      </td>
      <td className="trackers-channel-col">{channel}</td>
    </tr>
  );
};

export default TrackersRow;
